import { stringToHTML, generateUUID } from './helper';
import * as consts from './const';
import Swal from 'sweetalert2';

export default (editor, opts = {}) => {
    const commands = editor.Commands;
    
    editor.Config.canvasCss += consts.spinner_css;
    commands.add('create-spinner', {
        run:async function (editor, sender, params) {
            let canvas_document = editor.Canvas.getDocument();
            let canvas_body = canvas_document.querySelector('body');
            let spinner_html = /*html*/`
                <div id="spinner-template">
                    <div class="spinner-body">
                        <svg class="spinner" viewBox="0 0 50 50">
                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
                
            `
            let spinner_dom = stringToHTML(spinner_html).childNodes[0];

            editor.runCommand('remove-spinner');
            canvas_body.appendChild(spinner_dom);

        }
    });

    commands.add('remove-spinner', {
        run:async function (editor, sender, params) {
            
            let canvas_document = editor.Canvas.getDocument();
            let canvas_body = canvas_document.querySelector('body');
            let spinner_template = canvas_body.querySelector('#spinner-template');
            if(spinner_template){
                spinner_template.remove();
            }
            
            
        }
    });

    commands.add('clean-forms', {
        run:async function (editor, sender, params) {
            try {
                let editor_wrapper = editor.getWrapper();
                let list_forms = editor_wrapper.findType('form');
                
                if(list_forms.length == 0)
                    return
                Swal.fire({
                    title: 'Clean froms?',
                    text: "Do you want to clean the forms?",
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    heightAuto:false,
                    buttonsStyling:false,
                    customClass: {
                        confirmButton: 'btn btn-primary mr-3 py-1 px-3',
                        cancelButton: 'btn btn-danger py-1 px-3'
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        for (let i = 0; i < list_forms.length; i++) {
                            
                            let form_components = list_forms[i].components();
                            let to_remove = [];
                            for (let i = 0; i < form_components.length; i++) {
                                const component = form_components.models[i];
                                let find = component.find('.btn[type=submit]');
                                if(find.length == 0){
                                    to_remove.push(component);
                                }
                            }
                            for (let i = 0; i < to_remove.length; i++) {
                                const element = to_remove[i];
                                
                                let find = form_components.find((item)=>{
                                    return item.getId() == element.getId();
                                });
                                if(find){
                                    find.remove();
                                }
                            }
                        }
                    }
                });
            } catch (error) {
                console.log(error);
            }
            
        }
    });
}